import { showErrorToast } from "@shared/toasts/Toasts";

function invalidateOnSuccess<T extends string>(...tags: T[]) {
    return (_result: unknown, error: unknown) => (error ? [] : tags);
}

function transformErrorResponse(err: unknown, fallbackMessage: string): Error {
    const error = err as Error;
    showErrorToast(error.message || fallbackMessage);
    return new Error(error.message || fallbackMessage);
}

export { invalidateOnSuccess, transformErrorResponse };
